import { AnswerTemplate } from './../../../_models/answerTemplate';
import { AdminService } from './../../../_services/admin.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
declare var $ : any;
@Component({
  selector: 'app-answer-template-rename',
  templateUrl: './answer-template-rename.component.html',
  styleUrls: ['./answer-template-rename.component.css']
})
export class AnswerTemplateRenameComponent implements OnInit {
  @Input() answerTemplate:AnswerTemplate =  undefined
  @Output()  editAnswerTemplateFinishEvent= new EventEmitter<boolean>()
  loading=false
  errorSaving=false
  isSaving=false
  myForm:FormGroup
  constructor(private adminService:AdminService) { }

  get f(){
    return this.myForm.controls
  }
ngOnInit(): void {
  if(this.answerTemplate){
    this.myForm=new FormGroup({
      answerTemplateName: new FormControl(this.answerTemplate.name, [Validators.required,Validators.minLength(4)]),
    });
  }

  this.loading=true
  this.errorSaving=false
}
on_submit(){
  this.isSaving=true
  let dd=this.formatData(this.myForm.value.answerTemplateName)
  this.adminService.renameAnswerTemplate(dd).subscribe(
    val=>{
      if(val['server_answer_template_id']==0){
        this.errorSaving=true

      }
      else{
        this.answerTemplate=val
        this.loading=false
        this.editAnswerTemplateFinishEvent.emit(true)
        this.closeAnswerTemplateRenameModal()

      }
      this.isSaving=false
    }
  )

}
formatData(answerTemplateName:string){
  let data = new URLSearchParams();
  data.set('name', answerTemplateName);
  data.set('id', this.answerTemplate.server_answer_template_id.toString());
  return data.toString()
}
closeAnswerTemplateRenameModal(){
  $("#renameAnswerTemplateModal").modal("hide");
}

}
